export enum EventTypeEnum {
  ACCA_JBTI_2023 = 'ACCA_JBTI_2023',
  TALENT_POOL_PROFILE_INPUT = 'TALENT_POOL_PROFILE_INPUT',
  TALENT_POOL_ACC_TEST = 'TALENT_POOL_ACC_TEST',
  TALENT_POOL_FINAL = 'TALENT_POOL_FINAL',
  DEV_CHAMPS_2023_09 = 'DEV_CHAMPS_2023_09',
  DEV_CHAMPS_2023_10 = 'DEV_CHAMPS_2023_10',
  DEV_CHAMPS_2023_11 = 'DEV_CHAMPS_2023_11',
  TALENT_POOL_HOLIDAY_2023_10 = 'TALENT_POOL_HOLIDAY_2023_10',
  MATCHING_EVENT_2023 = 'MATCHING_EVENT_2023',
  PROFILE_EVENT_2023_12 = 'PROFILE_EVENT_2023_12',
  ACCA_JBTI_2024_01 = 'ACCA_JBTI_2024_01',
  TEST = 'TEST',
}

export type EventType = keyof typeof EventTypeEnum;
